<template>
    <v-card class="elevation-1 w100p">
        <v-toolbar flat color="grey lighten-4">
            <v-toolbar-title class="pl-3 grey--text text--darken-4">{{ title }}</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider></v-divider>
        <v-data-table
                :headers="fieldDefs"
                :items="items"
                hide-actions
                expand>
            <template slot="items" slot-scope="props">
                <tr @click="props.expanded = !props.expanded" class="cursor-pointer">
                    <template v-for="(header, h) in fieldDefs">
                        <td v-if="header.value === 'actions'" :class="'text-xs-'+header.align" style="width: 100px" :key="h">
                            <v-btn icon class="mx-0" @click.stop="editItem(props.item)">
                                <v-icon color="primary">edit</v-icon>
                            </v-btn>
                            <v-btn icon class="mx-0" @click.stop="deleteItem(props.item)">
                                <v-icon color="secondary">delete</v-icon>
                            </v-btn>
                        </td>
                        <td v-else-if="header.value === 'number'" :class="'text-xs-' + header.align" style="width: 40px" :key="h">
                            {{ props.index + 1 }}
                        </td>
                        <td v-else-if="header.value == 'price'" :class="'text-xs-' + header.align" :key="h">
                            {{ $eventBusUtility.headerValue(header.value, props.item) | currency }}
                        </td>
                        <td v-else-if="header.type == 'date'" :key="h"
							@click="openShow(props.item)">
							{{ formatDate(props.item[header.value]) }}
						</td>
                        <td v-else :class="'text-xs-' + header.align" :key="h">
                            {{ $eventBusUtility.headerValue(header.value, props.item) }}
                        </td>
                    </template>
                </tr>
            </template>
            <template slot="expand" slot-scope="props">
                <v-card flat :key="props.index">
                    <v-card-text pa-4 v-html="items[props.index].description"></v-card-text>
                </v-card>
            </template>
        </v-data-table>
        <component 
            :is="footerComponent"
            :items="items"
            :infoRelationshipData="infoRelationshipData"
            :params="params"
        ></component>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="1000px"
            lazy
            :fullscreen="$vuetify.breakpoint.xsOnly">
            <v-btn class="elevation-2"
                color="primary"
                slot="activator"
                dark
                small
                absolute
                bottom
                left
                fab
                >
                <v-icon>add</v-icon>
            </v-btn>
            <v-card v-if="dialog">
                <v-toolbar flat color="grey lighten-4">
                    <v-toolbar-title class="pl-3 grey--text text--darken-3">{{ titleDialog }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-divider></v-divider>
                <v-card-text class="pt-0">
                    <v-container fluid pt-3 pa-2>

                        <fields-generator
                            :layoutClass="['row','wrap']" 
                            :fields="fieldsset"
                            :model="editedItem"
                            ref="fieldsgenerator"
                            :selectChange="updateSelectText"
                        ></fields-generator>

                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native="close">Chiudi</v-btn>
                    <v-btn color="primary" flat @click.native="save">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import Vue from 'vue'
import FieldsGenerator from '@/components/FieldsGenerator'

export default {
	name: 'crud-table-relationship',
	components: {
		FieldsGenerator
	},

	props: {
		title: String,
		titleDialog: String,
		infoRelationshipUrl: String,
		children: Array,
		footerComponent: String,
		keyOfModelCascade: String,
		urlOfModelCascade: String,
		keyOfModel: String,
		defaultInput: Object,
		params: Object
	},

	data() {
		return {
			dialog: false,
			infoRelationshipData: {},
			fieldsset: [],
			items: this.children,
			modelPrimaryField: '',
			editedIndex: -1,
			editedItem: { description: '' },
			defaultItem: { description: '' },
			confirmDelete: false,
			dummyId: 0,
			empty: 'a',
			modelForAutocomplete: []
		}
	},

	computed: {
		fieldDefs() {
			if (this.infoRelationshipData.info) {
				return this.infoRelationshipData.info.fieldDefs
			}
		},

		formatDate() {
			return date => {
				return moment(date).format('D/MM/YYYY')
			}
		}
	},

	watch: {
		dialog(val) {
			if (val === true) {
				// Validations for custom fields
			} else {
				this.close()
			}
		}
	},

	created() {
		this.initialize()
	},

	methods: {
		initialize() {
			this.axios.get(this.infoRelationshipUrl).then(response => {
				this.infoRelationshipData = response.data
				this.fieldsset = response.data.fields

				_.forEach(this.fieldsset.fields, (value, key) => {
					if (value.default) {
						Vue.set(this.editedItem, value.key, value.default)
					}
				})
			},
			response => {
				// error callback
			})
		},

		// At select product precompile inputs
		updateSelectText(field, id) {
			Vue.nextTick(() => {
				// If field.key === 'product_id' ajax call for show product
				if (typeof id !== 'object') {
					if (field.key === this.keyOfModelCascade && id) {
						this.axios.get(this.urlOfModelCascade + '/' + id).then(response => {
							this.modelForAutocomplete = response.data.model
							// For each fields in dialog set value in editedItem
							Vue.set(this.editedItem,
								this.keyOfModelCascade + '_text',
								this.modelForAutocomplete[this.keyOfModel])
							_.forEach(this.infoRelationshipData.fields.fields,
								(value, key) => {
									if (this.modelForAutocomplete[value.key] != undefined) {
										Vue.set(this.editedItem,
											value.key,
											this.modelForAutocomplete[value.key])
										if (
											this.modelForAutocomplete[value.key + '_text'] !=                        undefined
										) {
											Vue.set(this.editedItem,
												value.key + '_text',
												this.modelForAutocomplete[value.key + '_text'])
										}
									}
								})
							// Set defaultInput in input
							_.forEach(this.defaultInput, (value, key) => {
								if (value.text) {
									Vue.set(this.editedItem, key + '_text', value.text)
									Vue.set(this.editedItem, key, value.value)
								} else {
									Vue.set(this.editedItem, key, value)
								}
							})
						},
						response => {
							// error callback
						})
					} // Else if field is another field example vat and have options search text and write in editedItem
					else if (field.options) {
						let optionSelected = _.find(field.options, o => {
							return o.value === id
						})
						if (optionSelected) {
							Vue.set(this.editedItem,
								field.key + '_text',
								optionSelected.text)
						}
					}
				}
			})
		},

		editItem(item) {
			this.editedIndex = this.items.indexOf(item)
			this.editedItem = Object.assign({}, item)
			this.dialog = true
		},

		deleteItem(item) {
			const index = this.items.indexOf(item)
			this.items.splice(index, 1)
			this.$eventBusUtility.$emit('updateChildren', this.items)
		},

		close() {
			this.dialog = false
			setTimeout(() => {
				// Empty deposit object
				this.editedItem = Object.assign({}, this.defaultItem)
				_.forEach(this.fieldsset.fields, (value, key) => {
					if (value.default) {
						Vue.set(this.editedItem, value.key, value.default)
					}
				})
				this.editedIndex = -1
			}, 300)
		},

		save() {
			this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
				if (result) {
					// If edit, use index and update object in items
					if (this.editedIndex > -1) {
						Object.assign(this.items[this.editedIndex], this.editedItem)
					} else {
						// If new, index not needed, push new object in items
						Vue.set(this.editedItem, 'id', this.dummyId)
						this.dummyId--
						this.items.push(this.editedItem)
					}
					this.$eventBusUtility.$emit('updateChildren', this.items)

					this.close()
				}
			})
		}
	}
}
</script>

<style scoped>
</style>
